import { Phone, Mail } from "lucide-react";
import { CONTACT } from "@/data/services";

/** Dunkelgrünes Kopfband für Leistungsseiten */
export default function PageHero({ eyebrow, title, description, testid }) {
  return (
    <section className="bg-[#122B18] text-white py-14 sm:py-20 border-b border-[#1E5631]" data-testid={testid}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-5 animate-in">
        <span className="inline-block text-xs font-bold text-[#A3D9A5] uppercase tracking-wider border border-[#1E5631] rounded-full px-3 py-1">
          {eyebrow}
        </span>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tight font-display leading-tight max-w-3xl">{title}</h1>
        <p className="text-[#D7E5D9] text-base sm:text-lg leading-relaxed max-w-2xl">{description}</p>
        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <a
            href={CONTACT.phoneHref}
            data-testid={`${testid}-call-button`}
            className="inline-flex justify-center items-center gap-2 bg-[#3D8B4D] hover:bg-[#4AA05C] text-white font-bold px-6 py-3.5 rounded-lg transition-colors text-sm sm:text-base"
          >
            <Phone className="w-4 h-4" /> {CONTACT.phoneDisplay}
          </a>
          <a
            href={CONTACT.emailHref}
            data-testid={`${testid}-mail-button`}
            className="inline-flex justify-center items-center gap-2 bg-white/10 hover:bg-white/20 border border-[#3D8B4D] text-white font-bold px-6 py-3.5 rounded-lg transition-colors text-sm sm:text-base"
          >
            <Mail className="w-4 h-4" /> E-Mail schreiben
          </a>
        </div>
      </div>
    </section>
  );
}
